import { apiRequest } from ".";

export const getSellerCommissionsRequest = (filters) => {
  const {
    page='',
    limit='',
    seller='',
    year=''
  } = filters;

  return apiRequest(
    `/admin/seller-commissions?page=${page}&limit=${limit}&seller=${seller}&year=${year}`,
    {
      method: 'GET'
    },
    true
  )
}

export const getSellerCommissionRequest = (id) => {
  return apiRequest(
    `/admin/seller-commissions/${id}`,
    {
      method: 'GET'
    },
    true
  )
}

export const createSellerCommissionRequest = (sellerCommission) => {
  return apiRequest(
    `/admin/seller-commissions`,
    {
      method: 'POST',
      body: JSON.stringify(sellerCommission)
    },
    true
  )
}   

export const updateSellerCommissionRequest = (sellerCommission) => {
  return apiRequest(
    `/admin/seller-commissions/${sellerCommission._id}`,
    {
      method: 'PUT',
      body: sellerCommission
    },
    true
  )
}

export const deleteSellerCommissionRequest = (id) => {
  return apiRequest(
    `/admin/seller-commissions/${id}`,
    {
      method: 'DELETE'
    },
    true
  )
}